/* <i80-calendar>: an i80 component of our own (not in Helios), built only from i80 tokens. */
.i80-calendar {
  color: var(--i80-color-foreground-primary);
  font-family: var(--i80-typography-font-stack-text);
}

.i80-calendar__header {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.i80-calendar__title {
  margin: 0;
  color: var(--i80-color-foreground-strong);
  font-weight: var(--i80-typography-font-weight-semibold);
  font-size: var(--i80-typography-display-200-font-size);
  line-height: var(--i80-typography-display-200-line-height);
}

.i80-calendar__nav {
  display: flex;
  gap: 8px;
}

.i80-calendar__grid {
  width: 100%;
  border: 1px solid var(--i80-color-border-primary);
  border-radius: var(--i80-border-radius-medium);
  border-spacing: 0;
  table-layout: fixed;
  background: var(--i80-color-surface-primary);
}

.i80-calendar__weekday {
  padding: 8px;
  color: var(--i80-color-foreground-faint);
  font-weight: var(--i80-typography-font-weight-medium);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: var(--i80-typography-body-100-line-height);
  text-align: left;
  border-bottom: 1px solid var(--i80-color-border-primary);
}

.i80-calendar__day {
  height: 104px;
  padding: 4px;
  vertical-align: top;
  border-bottom: 1px solid var(--i80-color-border-faint);
  border-left: 1px solid var(--i80-color-border-faint);
}

.i80-calendar__day:first-child {
  border-left: 0;
}

.i80-calendar__grid tbody tr:last-child .i80-calendar__day {
  border-bottom: 0;
}

.i80-calendar__day--outside {
  background: var(--i80-color-surface-faint);
}

.i80-calendar__date {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  margin: 0 0 4px;
  padding: 0 6px;
  color: var(--i80-color-foreground-strong);
  font: inherit;
  font-weight: var(--i80-typography-font-weight-medium);
  font-size: var(--i80-typography-body-200-font-size);
  background: transparent;
  border: 0;
  border-radius: 14px;
  cursor: pointer;
}

.i80-calendar__date:hover {
  background: var(--i80-color-surface-interactive-hover);
}

.i80-calendar__date:focus-visible {
  outline: 3px solid var(--i80-color-focus-action-external);
  outline-offset: 0;
  box-shadow: inset 0 0 0 1px var(--i80-color-focus-action-internal);
}

.i80-calendar__day--outside .i80-calendar__date {
  color: var(--i80-color-foreground-faint);
}

.i80-calendar__day--today .i80-calendar__date {
  color: var(--i80-color-foreground-action);
  background: var(--i80-color-surface-action);
}

.i80-calendar__day--selected .i80-calendar__date,
.i80-calendar__day--selected .i80-calendar__date:hover {
  color: var(--i80-color-foreground-high-contrast);
  background: var(--i80-color-palette-blue-200);
}

.i80-calendar__events {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.i80-calendar__event {
  display: block;
  overflow: hidden;
  padding: 1px 6px;
  color: var(--i80-color-foreground-primary);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: var(--i80-typography-body-100-line-height);
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  background: var(--i80-color-surface-strong);
  border-radius: var(--i80-border-radius-small);
}

a.i80-calendar__event:hover {
  text-decoration: underline;
}

a.i80-calendar__event:focus-visible {
  outline: 2px solid var(--i80-color-focus-action-external);
}

.i80-calendar__event--color-action { color: var(--i80-color-foreground-action); background: var(--i80-color-surface-action); }
.i80-calendar__event--color-success { color: var(--i80-color-foreground-success-on-surface); background: var(--i80-color-surface-success); }
.i80-calendar__event--color-warning { color: var(--i80-color-foreground-warning-on-surface); background: var(--i80-color-surface-warning); }
.i80-calendar__event--color-critical { color: var(--i80-color-foreground-critical-on-surface); background: var(--i80-color-surface-critical); }

/* Week view: one row per day, as an agenda. */
.i80-calendar__week {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--i80-color-border-primary);
  border-radius: var(--i80-border-radius-medium);
  background: var(--i80-color-surface-primary);
}

.i80-calendar__week > li {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
  align-items: start;
  height: auto;
  padding: 8px 12px;
  border-top: 1px solid var(--i80-color-border-faint);
  border-bottom: 0;
  border-left: 0;
}

.i80-calendar__week > li:first-child {
  border-top: 0;
}

.i80-calendar__week .i80-calendar__date {
  justify-content: flex-start;
  width: 100%;
}

.i80-calendar__week .i80-calendar__events {
  gap: 4px;
  padding-top: 5px;
}

.i80-calendar__week .i80-calendar__events > li {
  display: grid;
  grid-template-columns: 112px 1fr;
  gap: 8px;
  align-items: baseline;
}

.i80-calendar__event-time {
  color: var(--i80-color-foreground-faint);
  font-size: var(--i80-typography-body-100-font-size);
  font-variant-numeric: tabular-nums;
}

.i80-calendar__grid .i80-calendar__event-time {
  margin-right: 4px;
  color: inherit;
  opacity: 0.75;
}

.i80-calendar__empty {
  color: var(--i80-color-foreground-faint);
  font-size: var(--i80-typography-body-100-font-size);
  line-height: 28px;
}

@media (max-width: 600px) {
  .i80-calendar__day {
    height: 56px;
  }

  .i80-calendar__grid .i80-calendar__event {
    height: 6px;
    padding: 0;
    font-size: 0;
  }
}
